export default __webpack_public_path__ + "static/media/Logo-Biotec.816b2ce6.png";